import { SliderNotches } from "..";

export const useIsTooltipNotches = (notches: SliderNotches) =>
  !notches || !notches.length ? false : typeof notches[0] !== "number";
